<!-- <img  *ngIf="!IsImageError" alt="picture" src="{{cover}}" class="{{cssStyle}} cover" (error)="imagerror($event)" />

<img  *ngIf="IsImageError" [src]="noimg" class="{{cssStyle}} cover" alt="img-default" /> -->

<!-- <img  alt="Homepicture" src="{{cover}}" class="{{cssStyle}} cover" (error)="imagerror($event)" /> -->
 
<div class="position-relative">
  <img 
      [src]="cover"
      [alt]="'Homepicture'"
      [class]="cssStyle + ' cover'"
      (error)="imagerror($event)"
    />

    <span *ngIf="cover.includes('assets/images/bookcover')"
      class="position-absolute top-50 start-50 translate-bookcover z-1 text-wrap text-bookcover text-end"
    >
      {{title}}
    </span>
</div>
  
<!-- (error)="doSomethingOnError()" -->
<!-- onError="this.src='assets/images/bookcover/noimage.jpg'" -->